/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.14.1
 */
import { createAction } from '../../modules/app/createAction';
import {
    IWizardBillsDocValidateFinishPayload,
    TWizardBillsDocHandleNextAction,
    TWizardBillsDocSetParamsAction,
    TWizardBillsDocSetParamsPayload,
    TWizardBillsDocValidateFinishAction,
    TWizardBillsDocValidateStartAction,
} from './types/wizardBillsDocActionTypes';
import {
    WIZARD_BILLS_DOC_HANDLE_NEXT,
    WIZARD_BILLS_DOC_SET_PARAMS,
    WIZARD_BILLS_DOC_VALIDATE_FINISH,
    WIZARD_BILLS_DOC_VALIDATE_START,
} from './wizardBillsDocConsant';

/*
* -------------------------------------------
*           VALIDATE
* -------------------------------------------
*/

export const wizardBillsDocValidateStartAction = (): TWizardBillsDocValidateStartAction =>
    createAction(WIZARD_BILLS_DOC_VALIDATE_START);

export const wizardBillsDocValidateFinishAction = (payload: IWizardBillsDocValidateFinishPayload):
    TWizardBillsDocValidateFinishAction =>
    createAction(WIZARD_BILLS_DOC_VALIDATE_FINISH, payload);

/*
* -------------------------------------------
*           SET PARAMS
* -------------------------------------------
*/

export const wizardBillsDocSetParamsAction = (payload: TWizardBillsDocSetParamsPayload):
    TWizardBillsDocSetParamsAction =>
    createAction(WIZARD_BILLS_DOC_SET_PARAMS, payload);

/*
* -------------------------------------------
*               NEXT
* -------------------------------------------
*/

export const wizardBillsDocHandleNextAction = (): TWizardBillsDocHandleNextAction =>
    createAction(WIZARD_BILLS_DOC_HANDLE_NEXT);
